import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Observable, Subject } from 'rxjs';
import { ErrorService } from 'src/app/error.service';
import { GeneralService } from 'src/app/service/general.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { getPayorMap } from './group-payor-mapping-modal';

@Injectable({
  providedIn: 'root'
})
export class GroupPayorMappingDataService extends Subject<DataStateChangeEventArgs> {
   
    constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent,public general:GeneralService,private ngxService: NgxUiLoaderService){
          super();
        }



      public executeTransactionMenu(state: getPayorMap): void {
        this.getMappingPayorList(state).subscribe(x => super.next(x));
      }
     
      getMappingPayorList(state?: getPayorMap): Observable<DataStateChangeEventArgs> {
        return this.http.post<any>("api/Payerservice/GetPayerService", state)
          .pipe(map(
            (response: any) =>
              <any>{
                result: response['result'],
                count: response['count']
              }
          ))
    
    
      }
}

